import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { useIntl, defineMessages } from 'dibs-react-intl';
import { NftItemTileItemDetails } from '../NftItemTileItemDetails';

import commonStyles from './styles/nftItemTileContent.scss';
import styles from './styles/BurnedItemTileContent.scss';
import { type BurnedItemTileContent_nftItem$key } from './__generated__/BurnedItemTileContent_nftItem.graphql';

const messages = defineMessages({
    unavailable: {
        id: 'nftItemTile.burnedToken.unavailable',
        defaultMessage: 'Unavailable',
    },
    noMetadata: {
        id: 'nftItemTile.burnedToken.noMetadata',
        defaultMessage: 'Token burned. Metadata not available.',
    },
    tokenId: {
        id: 'nftItemTile.burnedToken.tokenId',
        defaultMessage: 'Token ID:',
    },
});

const nftItemFragment = graphql`
    fragment BurnedItemTileContent_nftItem on NftItem {
        tokenId
        metadata {
            ... on NftDigitalArtMetadata {
                name
            }
        }
        ...NftItemTileItemDetails_nftItem
    }
`;

type Props = {
    nftItem: BurnedItemTileContent_nftItem$key;
    creatorDisplay: 'link' | 'text';
};

export const BurnedItemTileContent: FC<Props> = ({ nftItem: nftItemRef, creatorDisplay }) => {
    const intl = useIntl();
    const nftItem = useFragment(nftItemFragment, nftItemRef);
    const hasMetadata = !!nftItem.metadata?.name;

    return (
        <div className={commonStyles.collectorDetails}>
            {hasMetadata ? (
                <NftItemTileItemDetails
                    nftItem={nftItem}
                    fireTracking={() => {}}
                    creatorDisplay={creatorDisplay}
                />
            ) : (
                <>
                    <div className={styles.bold}>{intl.formatMessage(messages.noMetadata)}</div>
                    <div>
                        <span className={styles.tokenIdLabel}>
                            {intl.formatMessage(messages.tokenId)}
                        </span>
                        <span>{nftItem.tokenId}</span>
                    </div>
                </>
            )}

            <p className={styles.unavailable}>{intl.formatMessage(messages.unavailable)}</p>
        </div>
    );
};
